import {
    postData,
    getDataWithParams,
    destroyData,
    getData,
    patchData
} from '@/store/config/method'
const initialState = () => ({
    item: [],
    list: {last_page: 0, data: [], total: 0},
    list2: {last_page: 0, data: [], total: 0},
    detail: { jobvacancy: {}, mysubmittion: null},
    mysubmission: {last_page: 0, data: [], total: 0},
    myjobseeker: {last_page: 0, data: [], total: 0},
    listjobvacancy: [],
    request: {
        page: 1,
        show: 10,
        sortBy: "status",
        sorting: "DESC",
        search: null,
        jobVacancyId: null,
    },
    request2: {
        show: 10,
        page: 1,
        location: 'Semua Lokasi',
        department: 'Semua Department',
        employment_type: 'Semua Jenis Pekerjaan'
    },
    request3: {
        page: 1,
        show: 100,
        event: 'Semua Acara',
        sortBy: "updated_at",
        sorting: "DESC",
        status: null,
    },
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState
const getters = {
    getItem: state => state.item,
    getList: state => state.list,
    getList2: state => state.list2,
    getDetail: state => state.detail,
    getRequest: state => state.request,
    getRequest2: state => state.request2,
    getRequest3: state => state.request3,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getMysubmission: state => state.mysubmission,
    getMyjobseeker: state => state.myjobseeker,
    getListjobvacancy: state => state.listjobvacancy,
}

const actions = {
    async fetchData({
        commit
    }, url) {
        try {
            var response = await getData(`/${url}`);
            commit('SET_ITEM', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getMySubmissionData({
        commit, state
    }, request) {
        try {
            var response = await getDataWithParams('/myjobsubmission',request);
            state.request3 = request
            commit('SET_MYSUBMISSION', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getMyjobseekerData({
        commit, state
    }, {url, request}) {
        try {
            const response = await getDataWithParams(`/${url}`,request);
            state.request = request
            commit('SET_MYJOBSEEKER', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async updateJobseekerStatus({
        commit
    }, {url, data}) {
        try {
            var response = await postData(`/${url}`,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getListjobvacancyData({
        commit
    }, url = 'event-job-vacancy/list') {
        try {
            var response = await getData(`/${url}`);
            commit('SET_LISTJOBVACANCY', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getJobVacancyDetail({
        commit
    }, slug) {
        try {
            var response = await getData(`/jobvacancy-detail/${slug}`);
            commit('SET_DETAIL', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async submitJob({
        commit
    }, slug) {
        try {
            var response = await getData(`/jobvacancy-detail/submit/${slug}`);
            commit('SET_DETAIL', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getListData({
        commit, state
    }, {url, request}) {
        try {
            var response = await getDataWithParams(`/${url}`,request);
            state.request = request
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async getActiveData({
        commit, state
    }, request) {
        try {
            var response = await getDataWithParams('/event-data/active/job-vacancy',request);
            state.request2 = request
            commit('SET_LIST2', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async submit({
        commit, state
    }, {url, data}) {
        try {
            var response = await postData(`/${url}`,data);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "status",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async updateStatus({
        commit, state
    }, url) {
        try {
            var response = await patchData(`/${url}`);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "status",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async destroy({
        commit, state
    }, url) {
        try {
            var response = await destroyData(`/${url}`);
            state.request = {
                page: 1,
                show: 10,
                sortBy: "status",
                sorting: "DESC",
                search: null,
            }
            commit('SET_LIST',response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_ITEM(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.item = response.data
    },
    SET_MYSUBMISSION(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.mysubmission = response.data
    },
    SET_MYJOBSEEKER(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.myjobseeker = response.data
    },
    SET_LISTJOBVACANCY(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.listjobvacancy = response.data
    },
    SET_DETAIL(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.detail = response.data
    },
    SET_LIST(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list = response.data
    },
    SET_LIST2(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.list2 = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}